function isObject(target) {
  return target != null && typeof target == "object";
}
function isUndefined(target) {
  return typeof target == "undefined";
}
function mapObject(callback, obj) {
  return Object.keys(obj).reduce((acc, key) => {
    const [k, v] = callback(key, obj[key]);
    acc[k] = v;
    return acc;
  }, {});
}

export { isObject, isUndefined, mapObject };
//# sourceMappingURL=shared.mjs.map
